export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["número"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ahorrar"])}
}